import headers from 'jsonHeaders'

export default id => fetch(`/api/system/products/${id}/pricing/`, { headers }).then(res => res.json())
